(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pack-subscribe-box"] && !Shopify.designMode) return;
  try {
    
  function apsFormatMoney(cents, format) {
    if (typeof cents !== 'number') return '';
    format = format || '${{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var cent = parts[1] ? decimal + parts[1] : '';
      return dollars + cent;
    }

    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  document.querySelectorAll('.aps-box').forEach(function (root) {
    if (root.dataset.apsInit) return;
    root.dataset.apsInit = 'true';

    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var defaultButtonLabel = root.dataset.buttonLabel || 'Checkout Now';
    var badgeTemplate = root.dataset.badgeTemplate || '{percent}% OFF';

    var dataEl = root.querySelector('[data-aps-variants]');
    var variants = JSON.parse(dataEl.textContent);

    var pills = root.querySelectorAll('.aps-pill');
    var subCard = root.querySelector('.aps-card--subscribe');
    var oneCard = root.querySelector('.aps-card--onetime');
    var badgeEl = root.querySelector('[data-aps-badge]');
    var checkoutBtn = root.querySelector('[data-aps-checkout]');
    var errorEl = root.querySelector('[data-aps-error]');

    var state = { variantIndex: 0, purchaseType: 'subscription' };

    function setCard(card, unitPrice, totalPrice, compareAt) {
      card.querySelector('[data-aps-unit-price]').textContent = apsFormatMoney(unitPrice, moneyFormat);
      card.querySelector('[data-aps-total]').textContent = apsFormatMoney(totalPrice, moneyFormat);
      var compareEl = card.querySelector('[data-aps-compare]');
      if (compareAt && compareAt > totalPrice) {
        compareEl.textContent = apsFormatMoney(compareAt, moneyFormat);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    function render() {
      var v = variants[state.variantIndex];
      var hasSub = v.sub_price !== null && v.sub_price !== undefined;

      if (hasSub) {
        subCard.style.display = '';
        setCard(subCard, v.sub_price, v.sub_price, v.sub_compare_at_price || v.compare_at_price);
      } else {
        subCard.style.display = 'none';
        if (state.purchaseType === 'subscription') state.purchaseType = 'onetime';
      }

      setCard(oneCard, v.price, v.price, v.compare_at_price);

      var activePrice = state.purchaseType === 'subscription' && hasSub ? v.sub_price : v.price;
      var activeCompare = state.purchaseType === 'subscription' && hasSub
        ? (v.sub_compare_at_price || v.compare_at_price)
        : v.compare_at_price;

      if (activeCompare && activeCompare > activePrice) {
        var pct = Math.round((1 - activePrice / activeCompare) * 100);
        badgeEl.textContent = badgeTemplate.replace('{percent}', pct);
        badgeEl.style.display = '';
      } else {
        badgeEl.style.display = 'none';
      }

      pills.forEach(function (pill, i) {
        var active = i === state.variantIndex;
        pill.classList.toggle('is-active', active);
        pill.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      subCard.classList.toggle('is-active', state.purchaseType === 'subscription');
      subCard.setAttribute('aria-checked', state.purchaseType === 'subscription' ? 'true' : 'false');
      oneCard.classList.toggle('is-active', state.purchaseType === 'onetime');
      oneCard.setAttribute('aria-checked', state.purchaseType === 'onetime' ? 'true' : 'false');
    }

    pills.forEach(function (pill, i) {
      pill.addEventListener('click', function () {
        state.variantIndex = i;
        render();
      });
    });

    subCard.addEventListener('click', function () {
      state.purchaseType = 'subscription';
      render();
    });

    oneCard.addEventListener('click', function () {
      state.purchaseType = 'onetime';
      render();
    });

    checkoutBtn.addEventListener('click', function () {
      var v = variants[state.variantIndex];
      var item = { id: v.id, quantity: 1 };
      if (state.purchaseType === 'subscription' && v.selling_plan_id) {
        item.selling_plan = v.selling_plan_id;
      }

      errorEl.hidden = true;
      checkoutBtn.disabled = true;
      checkoutBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { return Promise.reject(err); });
          return res.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          errorEl.textContent = (err && err.description) || 'Something went wrong. Please try again.';
          errorEl.hidden = false;
          checkoutBtn.disabled = false;
          checkoutBtn.textContent = defaultButtonLabel;
        });
    });

    render();
  });

  } catch(e) { console.error(e); }
})();
})();
